module.exports = __webpack_public_path__ + "static/img/qrcode1.0020cd2e.png";